import { HTMLAttributes, ReactNode } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface IconButtonWrapperProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size?: number;
  as?: React.ElementType<any>;
}

export default function IconButtonWrapper({
  children,
  size,
  onClick,
  as,
  ...props
}: IconButtonWrapperProps) {
  return (
    <Container as={as} size={size} onClick={onClick} {...props}>
      {children}
    </Container>
  );
}

const Container = styled.div<IconButtonWrapperProps>`
  ${({ size }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${size ? `${size}px` : '44px'};
    height: ${size ? `${size}px` : '44px'};
    cursor: pointer;
  `}
`;
